export default (theme) => ({
    root: {
        height: '100%',
        width: '100%',
    },
    chartCanvas: {
        borderRadius: '8px',
        cursor: 'default',
    },
});
